import rootStyles from "@mittwald/flow-styles/dist/mixins/rootStyles";
import unFlowRootStyles from "@mittwald/flow-styles/dist/mixins/unFlowRootStyles";
import { createGlobalStyle } from "styled-components";
import { elementBreakpointsGlobalStyle } from "../../../hooks/useElemBreakpoints";
/** @internal */
export const AppRootStyles = createGlobalStyle `
  ${elementBreakpointsGlobalStyle};
  ${rootStyles};
  
  vite-error-overlay,
  vite-plugin-checker-error-overlay {
    ${unFlowRootStyles}
  }
`;
/** @internal */
export default AppRootStyles;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwUm9vdFN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FwcEJvb3RzdHJhcC9jb21wb25lbnRzL0FwcFJvb3RTdHlsZXMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sVUFBVSxNQUFNLDhDQUE4QyxDQUFDO0FBQ3RFLE9BQU8sZ0JBQWdCLE1BQU0sb0RBQW9ELENBQUM7QUFDbEYsT0FBTyxFQUFFLGlCQUFpQixFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFDdEQsT0FBTyxFQUFFLDZCQUE2QixFQUFFLE1BQU0sbUNBQW1DLENBQUM7QUFFbEYsZ0JBQWdCO0FBQ2hCLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxpQkFBaUIsQ0FBQTtJQUMxQyw2QkFBNkI7SUFDN0IsVUFBVTs7OztNQUlSLGdCQUFnQjs7Q0FFckIsQ0FBQztBQUVGLGdCQUFnQjtBQUNoQixlQUFlLGFBQWEsQ0FBQyJ9